export default {
	"--scrim-light-standard": "0 0 0",
	"--scrim-dark-standard": "0 0 0",
	"--scrim-light-high": "0 0 0",
	"--scrim-dark-high": "0 0 0",
	"--primary-light-standard": "100 85 143",
	"--primary-dark-standard": "207 189 254",
	"--primary-light-high": "80 65 121",
	"--primary-dark-high": "207 189 254",
	"--primary-container-light-standard": "232 221 255",
	"--primary-container-dark-standard": "76 62 117",
	"--primary-container-light-high": "123 107 167",
	"--primary-container-dark-high": "122 106 165",
	"--on-primary-light-standard": "255 255 255",
	"--on-primary-dark-standard": "53 39 93",
	"--on-primary-light-high": "255 255 255",
	"--on-primary-dark-high": "34 18 73",
	"--on-primary-container-light-standard": "32 16 71",
	"--on-primary-container-dark-standard": "232 221 255",
	"--on-primary-container-light-high": "255 255 255",
	"--on-primary-container-dark-high": "255 255 255",
	"--inverse-primary-light-standard": "207 189 254",
	"--inverse-primary-dark-standard": "100 85 143",
	"--inverse-primary-light-high": "207 189 254",
	"--inverse-primary-dark-high": "85 70 126",
	"--primary-fixed-light-standard": "232 221 255",
	"--primary-fixed-dark-standard": "232 221 255",
	"--primary-fixed-light-high": "123 107 167",
	"--primary-fixed-dark-high": "232 221 255",
	"--primary-fixed-dim-light-standard": "207 189 254",
	"--primary-fixed-dim-dark-standard": "207 189 254",
	"--primary-fixed-dim-light-high": "98 83 140",
	"--primary-fixed-dim-dark-high": "207 189 254",
	"--on-primary-fixed-light-standard": "32 16 71",
	"--on-primary-fixed-dark-standard": "32 16 71",
	"--on-primary-fixed-light-high": "255 255 255",
	"--on-primary-fixed-dark-high": "32 16 71",
	"--on-primary-fixed-variant-light-standard": "76 62 117",
	"--on-primary-fixed-variant-dark-standard": "76 62 117",
	"--on-primary-fixed-variant-light-high": "255 255 255",
	"--on-primary-fixed-variant-dark-high": "67 52 107",
	"--secondary-light-standard": "98 91 113",
	"--secondary-dark-standard": "203 194 220",
	"--secondary-light-high": "77 71 91",
	"--secondary-dark-high": "203 194 220",
	"--secondary-container-light-standard": "232 222 248",
	"--secondary-container-dark-standard": "73 68 88",
	"--secondary-container-light-high": "120 113 135",
	"--secondary-container-dark-high": "119 112 134",
	"--on-secondary-light-standard": "255 255 255",
	"--on-secondary-dark-standard": "51 45 65",
	"--on-secondary-light-high": "255 255 255",
	"--on-secondary-dark-high": "31 26 45",
	"--on-secondary-container-light-standard": "30 25 43",
	"--on-secondary-container-dark-standard": "232 222 248",
	"--on-secondary-container-light-high": "255 255 255",
	"--on-secondary-container-dark-high": "255 255 255",
	"--secondary-fixed-light-standard": "232 222 248",
	"--secondary-fixed-dark-standard": "232 222 248",
	"--secondary-fixed-light-high": "120 113 135",
	"--secondary-fixed-dark-high": "232 222 248",
	"--secondary-fixed-dim-light-standard": "203 194 220",
	"--secondary-fixed-dim-dark-standard": "203 194 220",
	"--secondary-fixed-dim-light-high": "95 89 110",
	"--secondary-fixed-dim-dark-high": "203 194 220",
	"--on-secondary-fixed-light-standard": "30 25 43",
	"--on-secondary-fixed-dark-standard": "30 25 43",
	"--on-secondary-fixed-light-high": "255 255 255",
	"--on-secondary-fixed-dark-high": "30 25 43",
	"--on-secondary-fixed-variant-light-standard": "73 68 88",
	"--on-secondary-fixed-variant-dark-standard": "73 68 88",
	"--on-secondary-fixed-variant-light-high": "255 255 255",
	"--on-secondary-fixed-variant-dark-high": "64 59 79",
	"--tertiary-light-standard": "125 82 96",
	"--tertiary-dark-standard": "239 184 200",
	"--tertiary-light-high": "103 62 76",
	"--tertiary-dark-high": "239 184 200",
	"--tertiary-container-light-standard": "255 217 227",
	"--tertiary-container-dark-standard": "99 59 73",
	"--tertiary-container-light-high": "150 103 118",
	"--tertiary-container-dark-high": "148 102 117",
	"--on-tertiary-light-standard": "255 255 255",
	"--on-tertiary-dark-standard": "74 37 50",
	"--on-tertiary-light-high": "255 255 255",
	"--on-tertiary-dark-high": "51 18 31",
	"--on-tertiary-container-light-standard": "49 16 29",
	"--on-tertiary-container-dark-standard": "255 217 227",
	"--on-tertiary-container-light-high": "255 255 255",
	"--on-tertiary-container-dark-high": "255 255 255",
	"--tertiary-fixed-light-standard": "255 217 227",
	"--tertiary-fixed-dark-standard": "255 217 227",
	"--tertiary-fixed-light-high": "150 103 118",
	"--tertiary-fixed-dark-high": "255 217 227",
	"--tertiary-fixed-dim-light-standard": "239 184 200",
	"--tertiary-fixed-dim-dark-standard": "239 184 200",
	"--tertiary-fixed-dim-light-high": "123 79 94",
	"--tertiary-fixed-dim-dark-high": "239 184 200",
	"--on-tertiary-fixed-light-standard": "49 16 29",
	"--on-tertiary-fixed-dark-standard": "49 16 29",
	"--on-tertiary-fixed-light-high": "255 255 255",
	"--on-tertiary-fixed-dark-high": "49 16 29",
	"--on-tertiary-fixed-variant-light-standard": "99 59 73",
	"--on-tertiary-fixed-variant-dark-standard": "99 59 73",
	"--on-tertiary-fixed-variant-light-high": "255 255 255",
	"--on-tertiary-fixed-variant-dark-high": "89 50 63",
	"--surface-light-standard": "253 247 255",
	"--surface-dark-standard": "20 18 24",
	"--surface-light-high": "253 247 255",
	"--surface-dark-high": "20 18 24",
	"--on-surface-light-standard": "29 27 32",
	"--on-surface-dark-standard": "230 225 233",
	"--on-surface-light-high": "29 27 32",
	"--on-surface-dark-high": "242 236 244",
	"--on-surface-variant-light-standard": "73 69 78",
	"--on-surface-variant-dark-standard": "202 196 207",
	"--on-surface-variant-light-high": "73 69 78",
	"--on-surface-variant-dark-high": "202 196 207",
	"--inverse-surface-light-standard": "50 47 53",
	"--inverse-surface-dark-standard": "230 225 233",
	"--inverse-surface-light-high": "50 47 53",
	"--inverse-surface-dark-high": "230 225 233",
	"--inverse-on-surface-light-standard": "245 239 247",
	"--inverse-on-surface-dark-standard": "50 47 53",
	"--inverse-on-surface-light-high": "245 239 247",
	"--inverse-on-surface-dark-high": "50 47 53",
	"--surface-dim-light-standard": "222 216 224",
	"--surface-dim-dark-standard": "20 18 24",
	"--surface-dim-light-high": "222 216 224",
	"--surface-dim-dark-high": "20 18 24",
	"--surface-bright-light-standard": "253 247 255",
	"--surface-bright-dark-standard": "59 56 62",
	"--surface-bright-light-high": "253 247 255",
	"--surface-bright-dark-high": "59 56 62",
	"--surface-container-lowest-light-standard": "255 255 255",
	"--surface-container-lowest-dark-standard": "15 13 19",
	"--surface-container-lowest-light-high": "255 255 255",
	"--surface-container-lowest-dark-high": "15 13 19",
	"--surface-container-low-light-standard": "248 242 250",
	"--surface-container-low-dark-standard": "29 27 32",
	"--surface-container-low-light-high": "248 242 250",
	"--surface-container-low-dark-high": "29 27 32",
	"--surface-container-light-standard": "242 236 244",
	"--surface-container-dark-standard": "33 31 36",
	"--surface-container-light-high": "242 236 244",
	"--surface-container-dark-high": "33 31 36",
	"--surface-container-high-light-standard": "236 230 238",
	"--surface-container-high-dark-standard": "43 41 47",
	"--surface-container-high-light-high": "236 230 238",
	"--surface-container-high-dark-high": "43 41 47",
	"--surface-container-highest-light-standard": "230 225 233",
	"--surface-container-highest-dark-standard": "54 52 58",
	"--surface-container-highest-light-high": "230 225 233",
	"--surface-container-highest-dark-high": "54 52 58",
	"--background-light-standard": "253 247 255",
	"--background-dark-standard": "20 18 24",
	"--background-light-high": "253 247 255",
	"--background-dark-high": "20 18 24",
	"--on-background-light-standard": "29 27 32",
	"--on-background-dark-standard": "230 225 233",
	"--on-background-light-high": "29 27 32",
	"--on-background-dark-high": "230 225 233",
	"--outline-light-standard": "122 117 127",
	"--outline-dark-standard": "148 143 153",
	"--outline-light-high": "104 100 110",
	"--outline-dark-high": "157 152 163",
	"--outline-variant-light-standard": "202 196 207",
	"--outline-variant-dark-standard": "73 69 78",
	"--outline-variant-light-high": "142 137 148",
	"--outline-variant-dark-high": "118 113 123",
	"--error-light-standard": "186 26 26",
	"--error-dark-standard": "255 180 171",
	"--error-light-high": "153 0 11",
	"--error-dark-high": "255 180 171",
	"--error-container-light-standard": "255 218 214",
	"--error-container-dark-standard": "147 0 10",
	"--error-container-light-high": "218 52 46",
	"--error-container-dark-high": "216 51 45",
	"--on-error-light-standard": "255 255 255",
	"--on-error-dark-standard": "105 0 5",
	"--on-error-light-high": "255 255 255",
	"--on-error-dark-high": "68 0 2",
	"--on-error-container-light-standard": "65 0 2",
	"--on-error-container-dark-standard": "255 218 214",
	"--on-error-container-light-high": "255 255 255",
	"--on-error-container-dark-high": "255 255 255",
	"--shadow-light-standard": "0 0 0",
	"--shadow-dark-standard": "0 0 0",
	"--shadow-light-high": "0 0 0",
	"--shadow-dark-high": "0 0 0",
}
